// extracted by mini-css-extract-plugin
module.exports = {"deviceDetailsTitle":"_2msTPEnMRDj6qbrNpcqkKs","container":"_2gBUT0pjrDWYPishgA4HUp","deviceDetailsContainer":"_39QPIkDhigXc82vB9nbacj"};